export default __webpack_public_path__ + "static/media/BrandLogo.bfd0c759.png";